<template>
  <v-card outlined>
    <v-card-title>Évolution des tables</v-card-title>
    <v-card-text>
      <loader v-if="loading" />
      <div v-else-if="error" class="text-center">
        <v-alert type="error" outlined>
          {{ error }}
        </v-alert>
      </div>
      <div v-else-if="!hasData" class="text-center">
        <p>Aucune donnée disponible</p>
      </div>
      <div v-else>
        <v-row>
          <v-col
            v-for="tableName in tablesOrderedLabels"
            :key="tableName"
            cols="12"
            md="6"
            lg="4"
            class="mb-4"
          >
            <table-stats-chart
              :title="tableName"
              :data="getTableData(tableName)"
              :loading="loading"
            />
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import useAxios from "@/hooks/useAxios";
import TableStatsChart from "@/components/rmr-analytics/charts/TableStatsChart.vue";
import Loader from "@/components/common/Loader.vue";

export default {
  name: "TablesStatsGraphsCard",
  components: {
    TableStatsChart,
    Loader,
  },
  setup() {
    const { axiosGet } = useAxios();

    return {
      axiosGet,
    };
  },
  data() {
    return {
      loading: false,
      error: null,
      tablesOrderedLabels: [],
      tablesData: [],
    };
  },
  computed: {
    hasData() {
      return this.tablesOrderedLabels.length > 0 && this.tablesData.length > 0;
    },
  },
  created() {
    this.fetchTablesStats();
  },
  methods: {
    async fetchTablesStats() {
      this.loading = true;
      this.error = null;

      try {
        const response = await this.axiosGet("/tables-stats/evolution");
        this.tablesOrderedLabels = response.data.tables_ordered_labels || [];
        this.tablesData = response.data.items || [];
      } catch (error) {
        console.error("Failed to fetch tables stats:", error);
        this.error =
          "Erreur lors de la récupération des statistiques des tables";
      } finally {
        this.loading = false;
      }
    },

    getTableData(tableName) {
      const tableData = this.tablesData.find(
        (item) => item.table_name === tableName
      );
      return tableData ? tableData.data : [];
    },
  },
};
</script>

<style scoped>
.v-card {
  height: 100%;
}
</style>
